import { createSelector } from 'reselect';
import { selectPortfolioBalance } from 'features/invest/hooks/selectors';
import { selectPotsTotalBalance } from 'features/pots/reducers/selectors';
import { selectDefaultCurrency, selectFeed, selectFeatureFlag, } from 'reducers/selectors';
export const selectTotalNetworthBalance = createSelector(selectFeed, selectPotsTotalBalance, selectPortfolioBalance, selectDefaultCurrency, (feed, potsBalance, portfolioBalance, defaultCurrency) => ({
    amount: (feed.cards.overview?.netWorth?.amount || 0) +
        potsBalance.value +
        portfolioBalance.value,
    currency: feed.cards.overview?.netWorth?.currency || defaultCurrency,
}));
export const selectTotalAssetsBalance = createSelector(selectFeed, selectPotsTotalBalance, selectPortfolioBalance, selectDefaultCurrency, (feed, potsBalance, portfolioBalance, defaultCurrency) => ({
    amount: (feed.cards.overview?.totalAssets?.amount || 0) +
        potsBalance.value +
        portfolioBalance.value,
    currency: feed.cards.overview?.netWorth?.currency || defaultCurrency,
}));
export const selectTotalDebtsBalance = createSelector(selectFeed, selectDefaultCurrency, (feed, defaultCurrency) => ({
    amount: feed.cards.overview?.totalDebt?.amount || 0,
    currency: feed.cards.overview?.netWorth?.currency || defaultCurrency,
}));
export const selectShowNewPhysicalAssets = createSelector([(store) => selectFeatureFlag(store, 'physical_assets')], (featureFlag) => featureFlag.value);
export const selectShowTrueBalance = createSelector([
    (store) => store.deviceSettings.didViewTrueBalanceIntro,
    (store) => store.deviceSettings.didSetPeriod,
    (store) => store.user.user.currentPaydayRange,
], (didViewTrueBalanceIntro, didSetPeriod, currentPaydayRange) => didViewTrueBalanceIntro && (didSetPeriod || currentPaydayRange));
